"use client"
/* */
const getAriaSelectionMode = (selectionMode) => {
  return selectionMode === "navigation" ? "none" : selectionMode === "switch" ? "multiple" : selectionMode;
};
const getMenuItemSelectionVariant = (selectionMode) => {
  return selectionMode === "single" || selectionMode === "multiple" ? "control" : selectionMode;
};
const getCloseOverlayType = (selectionMode) => {
  return selectionMode === "multiple" || selectionMode === "switch" ? void 0 : "ContextMenu";
};

export { getAriaSelectionMode, getCloseOverlayType, getMenuItemSelectionVariant };
//# sourceMappingURL=lib.mjs.map
